import { useParams } from 'react-router-dom';
import TaskDetails from '@/pages/TaskDetails';
import ProjectViewRedirect from './ProjectViewRedirect';

const PlanRouter = () => {
  const { projectKey } = useParams();
  
  // Check if this is a task key (contains hyphen) vs project key
  const isTaskKey = projectKey && projectKey.includes('-');
  
  // Render the appropriate component based on the key type
  if (isTaskKey) {
    return <TaskDetails />;
  }
  
  return <ProjectViewRedirect />;
};

export default PlanRouter; 